export { default as InventoryRequestEmailEditViewStore } from './InventoryRequestEmailEditViewStore';